import { render, staticRenderFns } from "./BackItem.vue?vue&type=template&id=c59a6c10&"
import script from "./BackItem.vue?vue&type=script&lang=js&"
export * from "./BackItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports